import { projects } from "../types";


export const getProjectsListName = (customer_id, allowAll) => ({
    type: projects.PROJECT_LIST_NAMES_REQUEST,
    payload: { customer_id, allowAll }
})
